import { API_BASE_URL } from '@synergy/config';
import { Locale } from '@synergy/models';
import { createAction } from '@reduxjs/toolkit';

import { AppDispatch } from '../../store/store';
import { CategoryDto } from '../models/dto/category-dto';
import { ConfigApi } from '../api/configuration-api';
import { ConfigurationResponse } from '../api/models/configuration-response';
import { PoolSnackbar } from '../components/snackbars/pool-snackbar';
import { enqueueSnackbar } from './snackbar-actions';

const api = new ConfigApi(API_BASE_URL);

export const userChangeCompleted = createAction<void>('configuration/userChangeCompleted');
export const applicationConfigLoaded = createAction<ConfigurationResponse>('configuration/loaded');
export const categoriesLoaded = createAction<CategoryDto[]>('configuration/categories-loaded');

export const fetchApplicationConfig = () => async (dispatch: AppDispatch) => {
    const response = await api.getBaseState();
    if (response.success) {
        dispatch(applicationConfigLoaded(response.result));
    } else {
        dispatch(enqueueSnackbar(PoolSnackbar.fatal()));
    }
};

export const changeAccount = (accountId: number) => async (dispatch: AppDispatch) => {
    const response = await api.changeAccount(accountId);

    if (response.success) {
        dispatch(userChangeCompleted());
    } else {
        dispatch(enqueueSnackbar(PoolSnackbar.fatal()));
    }
};

export const changeLanguage = (locale: Locale) => async (dispatch: AppDispatch) => {
    const response = await api.changeLocale(locale);

    if (response.success) {
        dispatch(userChangeCompleted());
    } else {
        dispatch(enqueueSnackbar(PoolSnackbar.fatal()));
    }
};
